import { ComponentPropsWithRef } from "react";

export const CopyIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37.6 8H16.8V33.6H37.6V8ZM34.4 30.4H20V11.2H34.4V30.4ZM10.4 28.8V25.6H13.6V28.8H10.4ZM10.4 20H13.6V23.2H10.4V20ZM21.6 36.8H24.8V40H21.6V36.8ZM10.4 34.4V31.2H13.6V34.4H10.4ZM13.6 40H10.4V36.8H13.6V40ZM19.2 40H16V36.8H19.2V40ZM30.4 40H27.2V36.8H30.4V40ZM10.4 14.4H13.6V17.6H10.4V14.4Z"
      fill="currentColor"
    />
  </svg>
);
